var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 106,
    viewBox: "0 0 107 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_34_3939)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 53,
    r: 53,
    fill: "url(#paint0_linear_34_3939)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.1668 48.9997H70.8335V40.9997C70.8335 40.646 70.693 40.3069 70.443 40.0569C70.1929 39.8068 69.8538 39.6663 69.5002 39.6663H37.5002C37.1845 39.6715 36.8772 39.5644 36.633 39.3642C36.3888 39.164 36.2236 38.8836 36.1668 38.573V38.093C36.2236 37.7824 36.3888 37.502 36.633 37.3018C36.8772 37.1016 37.1845 36.9945 37.5002 36.9997H68.9402C69.2938 36.9997 69.6329 36.8592 69.883 36.6091C70.133 36.3591 70.2735 36.02 70.2735 35.6663C70.2735 35.3127 70.133 34.9736 69.883 34.7235C69.6329 34.4735 69.2938 34.333 68.9402 34.333H37.5002C36.4393 34.333 35.4219 34.7544 34.6718 35.5046C33.9216 36.2547 33.5002 37.2721 33.5002 38.333C33.4908 38.4929 33.4908 38.6531 33.5002 38.813V66.2397C33.5054 66.9576 33.652 67.6674 33.9316 68.3286C34.2111 68.9899 34.6182 69.5896 35.1296 70.0935C35.6409 70.5974 36.2465 70.9957 36.9118 71.2655C37.577 71.5354 38.289 71.6716 39.0068 71.6663H69.5002C69.8538 71.6663 70.1929 71.5259 70.443 71.2758C70.693 71.0258 70.8335 70.6866 70.8335 70.333V62.333H72.1668C72.5205 62.333 72.8596 62.1925 73.1097 61.9425C73.3597 61.6924 73.5002 61.3533 73.5002 60.9997V50.333C73.5002 49.9794 73.3597 49.6402 73.1097 49.3902C72.8596 49.1401 72.5205 48.9997 72.1668 48.9997ZM68.1668 68.9997H39.0068C38.2653 69.0068 37.5508 68.7209 37.019 68.204C36.4871 67.6871 36.1809 66.9812 36.1668 66.2397V42.173C36.5996 42.2984 37.05 42.3525 37.5002 42.333H68.1668V48.9997H58.8335C57.0654 48.9997 55.3697 49.702 54.1195 50.9523C52.8692 52.2025 52.1668 53.8982 52.1668 55.6663C52.1668 57.4344 52.8692 59.1301 54.1195 60.3804C55.3697 61.6306 57.0654 62.333 58.8335 62.333H68.1668V68.9997ZM70.8335 59.6663H58.8335C57.7726 59.6663 56.7552 59.2449 56.0051 58.4948C55.2549 57.7446 54.8335 56.7272 54.8335 55.6663C54.8335 54.6055 55.2549 53.5881 56.0051 52.8379C56.7552 52.0878 57.7726 51.6663 58.8335 51.6663H70.8335V59.6663Z",
    fill: "#F81DFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1799 57.667C61.2845 57.667 62.1799 56.7716 62.1799 55.667C62.1799 54.5624 61.2845 53.667 60.1799 53.667C59.0754 53.667 58.1799 54.5624 58.1799 55.667C58.1799 56.7716 59.0754 57.667 60.1799 57.667Z",
    fill: "#908294"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_34_3939",
    x: -19.5,
    y: -20,
    width: 146,
    height: 146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_34_3939"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_34_3939",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34_3939",
    x1: 0.5,
    y1: 0,
    x2: 78.5246,
    y2: 123.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.05
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.37e77b7eaedac838539027fddba7017b.svg";
export { ForwardRef as ReactComponent };